import React from 'react';
import { observer } from 'owa-mobx-react';
import { getCurrentRibbonTheme } from 'owa-acui-theme/lib/utils/getCurrentRibbonTheme';
import { ThemeProvider } from '@fluentui/react';
import { ensureAppThemeInitialized } from 'owa-acui-theme';

export const RibbonThemeV8: React.FC<{
    children: React.ReactNode;
}> = observer(({ children }) => {
    ensureAppThemeInitialized();

    return (
        <ThemeProvider applyTo="none" theme={getCurrentRibbonTheme()}>
            {children}
        </ThemeProvider>
    );
}, 'RibbonThemeV8');
